import moment from 'moment';
import React, { useState,useEffect,useCallback } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../../Dashboard/ChartComponents/Echarts/Echarts';
const PredictedGraph = (props) => {
  const [option, setOption] = useState(getOption());
  const [disableGraph, setDisableGraph] = useState(props.disableGraph);
  const [difMin, setDifMin] = useState(props.difMin);
  const [differenceHours, setDifferenceHours] = useState(props.differenceHours);
  //const [data, setData] = useState([]);
  useEffect(() => {
    getData(props.panelData.GraphData);
  }, [props.panelData.GraphData]);
  useEffect(() => {
    if (
      disableGraph !== props.disableGraph ||
      difMin !== props.difMin ||
      differenceHours !== props.differenceHours ||
      props.panelData !== props.panelData
    ) {
      setDisableGraph(props.disableGraph);
      setDifMin(props.difMin);
      setDifferenceHours(props.differenceHours);
      getData(props.panelData.GraphData);
    }
  }, [props]);
  const getData = useCallback(async (json) => {
    let series = [];
    json = props.panelData && props.panelData.GraphData ? props.panelData.GraphData : [];
   // json =[
    //   {
    //     "time": "2024-05-18 03:45:00+00",
    //     "count": 4,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:45:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 4          },
    //   {
    //     "time": "2024-05-18 03:46:00+00",
    //     "count":4 ,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:46:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 4
    //   },
    //   {
    //     "time": "2024-05-18 03:47:00+00",
    //     "count": 5,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:47:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 4
    //   },
    //   {
    //     "time": "2024-05-18 03:48:00+00",
    //     "count": 3,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:48:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 3
    //   },
    //   {
    //     "time": "2024-05-18 03:49:00+00",
    //     "count": 1,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:49:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 3
    //   },
    //   {
    //     "time": "2024-05-18 03:50:00+00",
    //     "count": 2,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:50:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 4
    //   },
    //   {
    //     "time": "2024-05-18 03:51:00+00",
    //     "count": 3,
    //     "tagsList": [],
    //     "notification": {
    //       "Timestamp": "2024-05-18 03:51:00+00",
    //       "NotificationId": null,
    //       "TagName": "TRR_TIA204_PV",
    //       "TagDescription": null,
    //       "Action": null
    //     },
    //     "status": 4
    //   }
    // ]
    const option = cloneDeep(option);
    if (json && Array.isArray(json)) {
      //let data = json;
      option.xAxis.data = json.map((item) => {
        return moment.utc(item.time, 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm');
      });
      series = [
        {
          name: 'Predicted Abnormal',
          barWidth: '60%',
          data: json.map((item) => (item && item.count ? item.count : 'null')),
          type: 'bar',
          color: 'steelblue',
        },
        {
          name: 'Actual Abnormal',
          symbolSize: 9,
          data: json.map((item) => {
            if (item && item.count && item.count > 0 && item.status === 4) {
              return item.count + 1;
            } else if (item.status === 4 && item.count === 0) {
              return 5;
            } else {
              return 'null';
            }
          }),
          type: 'scatter',
          color: 'yellow',
        },
        {
          name: 'Future Abnormal',
          barWidth: '60%',
          data: json.map((item) => (item && item.Future ? item.count : 'null')),
          type: 'bar',
          color: 'red',
        },
      ];
    }
    option.series = series;
    setOption(option);
    return option;
  }, [option, props]);
  const getOption = () => {
    return {
      backgroundColor: 'rgb(41, 65, 90)',
      title: {
        left: 'center',
        textStyle: {
          color: 'white',
          align: 'center',
        },
      },
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        axisLine: {
          lineStyle: {
            color: 'white',
          },
        },
        axisTick: {
          lineStyle: {
            color: 'white',
          },
        },
        axisLabel: {
          color: 'white',
          formatter: (value) => moment(value).format('HH:mm'),
        },
      },
      toolbox: {
        showTitle: false,
        orient: 'horizontal',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: '#011931',
            name: props.graphprops ? props.graphprops.title : 'name',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2,
            },
          },
        },
      },
      yAxis: {
        splitLine: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: 'white',
          },
        },
        axisTick: {
          lineStyle: {
            color: 'white',
          },
        },
        axisLabel: {
          color: 'white',
        },
      },
      dataZoom: [
        {
          // startValue: '2020-04-20'
        },
        {
          type: 'inside',
        },
      ],
      // legend: {
      //   right: 60,
      //   data: this.props.graphprops && this.props.graphprops.predictionsType === "arrayOfObject"
      //     ? ["Predicted Abnormal", "Actual Abnormal", "Future Abnormal"] : ["Anomaly", "Actual"],
      //   textStyle: {
      //     color: "white",
      //   },
      // }
    };
  };
    return (
      <React.Fragment>
        <ReactEcharts
          style={{ height: '90%', width: '200%' }}
          option={option}
          className="react_for_echarts"
        />
      </React.Fragment>
    );
};
export default PredictedGraph;
